const LineDoubtIcon = (props) => {
    return (
        <svg {...props} viewBox="0 0 1440 456" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M-14.0245 226.999C-145.862 305.111 -151.377 421.007 29.3708 446.421C561.668 521.263 834.341 85.2148 1299.89 11.5269C1384.98 -1.94163 1586.71 -20.7553 1555.1 76.8024" stroke="currentColor" strokeOpacity="0.16" strokeLinecap="round"/>
        </svg>
    )
}

export default LineDoubtIcon;